import { useEffect, type RefObject } from 'react';

const BASE = 12;
const CYCLE_MS = 14000;
const TICK_MS = 400;

/**
 * Ramps the number of visible embers from BASE up to `total` and back down
 * over a 14s cycle, matching the original prototype's exponential ramp.
 */
export function useEmberRamp(containerRef: RefObject<HTMLElement | null>, total: number) {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const embers = Array.from(container.querySelectorAll<HTMLElement>('[data-ember]'));
    if (embers.length === 0) return;

    const start = performance.now();
    let timer: ReturnType<typeof setTimeout>;

    const tick = () => {
      const t = (performance.now() - start) % CYCLE_MS;
      const half = CYCLE_MS / 2;
      let count: number;
      if (t < half) {
        count = Math.round(BASE * Math.pow(total / BASE, t / half));
      } else {
        const p = (t - half) / half;
        count = Math.round(total * Math.pow(BASE / total, p));
      }
      embers.forEach((el, i) => {
        el.style.visibility = i < count ? 'visible' : 'hidden';
      });
      timer = setTimeout(tick, TICK_MS);
    };
    tick();

    return () => clearTimeout(timer);
  }, [containerRef, total]);
}
